<template>
  <div class="newInvisitContent scrolled">
    <div>{{this.$t('NewInvitation')}}</div>
    <div class="new-invisit-content" ref="content">
      <div>
        <div class="new-invite-row invisitMessage">
          <div class="new-invite-title">{{$t('InvitationInfo')}}</div>
          <div>
            <div class="row" :class="{'form-error': errorMsgTypeSelect}">
              <div class="col-3">{{$t('visitType')}}</div>
              <div class="col-9 invisitArea typeList">
                <div @click="selectTypeShowHide">
                  <span>{{selectTypeShowTxt}}</span>
                  <i class="iconfont icon-right"></i>
                </div>
                <div>
                  <input type="hidden" v-model="typeId" name>
                </div>
                <ul v-show="selectTypeShow">
                  <li
                    v-for="type in typeList"
                    :key="type.id"
                    @click="handleTypeChange(type.id, type.name)"
                  >{{ type.name }}</li>
                </ul>
              </div>
            </div>
            <label class="error-msg" v-show="errorMsgTypeSelect">{{$t('SelectType')}}</label>
            <div class="row" :class="{'form-error': errorMsgAreaSelect}">
              <div class="col-3">{{$t('visitArea')}}</div>
              <div class="col-9 invisitArea typeList areaList" @click="checkTypeisNull">
                <div>
                  <span>{{selectAreaShowTxt}}</span>
                  <i class="iconfont icon-right" v-if="isShowAreaIcon"></i>
                </div>
                <div>
                  <input type="hidden" v-model="areaId" name>
                </div>
                <ul v-show="selectAreaShow">
                  <li
                    v-for="area in areaList"
                    :key="area.id"
                    @click="handleAreaChange(null, area.id, area.name)"
                  >{{ area.name }}</li>
                </ul>
              </div>
            </div>
            <label class="error-msg" v-show="errorMsgAreaSelect">{{$t('SelectVisitArea')}}</label>
            <div class="row" :class="{'form-error': errorMsgDate}">
              <div class="col-3">{{$t('VisitStart&EndTime')}}</div>
              <div class="col-9 invisitTime">
                <dateTimePicker
                  :isStartDate="true"
                  :type="'date'"
                  v-model="startEndDate"
                  :placeholder="$t('pleaseSelectAccessTime')"
                  @change="handleDateChange"
                ></dateTimePicker>
              </div>
            </div>
            <label class="error-msg" v-show="errorMsgDate">{{errorDate}}</label>
            <div class="row" :class="{'form-error': errorPeriodDate}">
              <div class="col-3">{{$t('ExpectedTime')}}</div>
              <div class="col-9 invisitPeriod typeList">
                <div @click="selectPeriodShowHide">
                  <span>{{selectPeriod}}</span>
                  <i class="iconfont icon-right"></i>
                </div>
                <div>
                  <input type="hidden" v-model="period_Id" name>
                </div>
                <ul v-show="selectPeriodShow">
                  <li
                    v-for="item in periodList"
                    :key="item.id"
                    @click="handlePeriodChange(item.id, item.name)"
                  >{{ item.name }}</li>
                </ul>
              </div>
            </div>
            <label class="error-msg" v-show="errorPeriodDate">{{notSelectPeriodDate}}</label>
            <div class="row bottlingSelect" :class="{'form-error': errorMsgBottlerSelect}">
              <div class="col-3">{{$t('bottler')}}</div>
              <div class="col-9 invisitBottling" @click="selectBottlerShowHide">
                <div :class="selectBottlerShow ? 'active': ''">
                  <span>{{selectBottlingShowTxt}}</span>
                  <i class="iconfont icon-right" v-if="isShowBottlersIcon"></i>
                </div>
              </div>
              <div v-show="selectBottlerShow" class="col-12 bottler-check">
                  <div v-for="bottler in bottlers"
                    :key="bottler.bottlerId" class="bottler-check-item">
                      <div class="l">
                        <label>
                          <input class="bottler-input" v-model="bottlerOption" type="checkbox" :value="bottler" >
                          {{ bottler.bottlerName }}
                        </label>
                      </div>
                      <div class="r">
                        <input class="order-input" style="border:1px solid #ccc" v-model="bottler.orderNumber" type="text" :placeholder="$t('WriteOrderNumber')"/>
                      </div>
                  </div>
                </div>
            </div>
            <label class="error-msg" v-show="errorMsgBottlerSelect">{{$t('chooseBottler')}}</label>
            <div class="btn-con">
              <div class="commit-btn first" @click="isClearData">
                <span>{{$t("empty")}}</span>
              </div>
              <div class="commit-btn" @click="checkData">
                <span>{{$t("submit")}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- first select type tips -->
    <!-- <alertModal
      modalType="simple"
      :isModalShown="isSelectTipsModalShown"
      :modalTitle="notSelectTips"
      @cancel="isSelectTipsModalShown = false"
    ></alertModal>-->
    <!-- first select type tips -->
    <alertModal
      modalType="simple"
      :isModalShown="isSelectTipsModalShown"
      :modalTitle="notSelectTips"
      @cancel="isSelectTipsModalShown = false"
    ></alertModal>
    <!-- first select bottler tips -->
    <alertModal
      modalType="simple"
      :isModalShown="isSelectBottlerTipsModalShown"
      :modalTitle="notSelectAearTips"
      @cancel="isSelectBottlerTipsModalShown = false"
    ></alertModal>
    <!-- confirm commit -->
    <alertModal
      :isModalShown="isCommit"
      :modalTitle="this.$t('IsCommit')"
      @cancel="isCommit = false"
      @confirm="commitData"
    ></alertModal>
    <!-- confirm commited -->
    <alertModal
      modalType="simple"
      :isModalShown="isConfirm"
      :modalTitle="addSucess"
      @cancel="closeModal"
    ></alertModal>

    <!-- confirm clear data -->
    <alertModal
      :isModalShown="isClear"
      :modalTitle="this.$t('IsClearAll')"
      @cancel="isClear = false"
      @confirm="clearData"
    ></alertModal>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>

<script type="text/javascript">
import alertModal from "@/components/alertModal.vue";
import dateTimePicker from "@/components/dateTimePicker.vue";
import Moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { getCarrierVisitType, getCarrierAreaList, getVisitorBottlers, getTimeSchedule, applyInvitation } from "@/utils/api";
import { checkNested } from "@/utils/utils";

export default {
  name: "newCarrierVisit",
  components: {
    dateTimePicker,
    alertModal,
    Loading
  },
  data() {
    return {
      typeList: [],
      areaList: [],
      periodList: [],
      bottlers: [],
      typeId: -1,
      areaId: -1,
      period_Id: -1,
      bottlerId: -1,
      selectTypeShow: false,
      selectTypeShowTxt: this.$t("SelectType"),
      selectAreaShow: false,
      selectAreaShowTxt: this.$t("SelectVisitArea"),
      errorMsgTypeSelect: false,
      errorMsgAreaSelect: false,
      errorMsgDate: false,
      errorDate: this.$t("entered"),
      errorPeriodDate: false,
      errorMsgBottlerSelect: false,

      isSelectTipsModalShown: false,
      notSelectTips: this.$t("PleaseChooseVisitType"),
      isSelectBottlerTipsModalShown: false,
      notSelectAearTips: this.$t("PleaseChooseVisitArea"),
      notSelectPeriodDate: this.$t("ExpectedTime"),

      isAreaDisabled: false,
      isShowAreaIcon: true,
      isShowBottlersIcon: true,

      startEndDate: "",
      selectPeriodShow: false,
      selectPeriod: this.$t("ExpectedTime"),
      selectBottlingShowTxt: this.$t("chooseBottler"),
      selectBottlerShow: false,
      orderNumber: "",
      isCommit: false,
      isConfirm: false,
      addSucess: this.$t("SubmittedSuccessfully"),
      isLoading: false,
      // isBottlersDisabled: false,
      DetailId: '',
      bottlerOption: [],
      isClear: false,
    };
  },
  created() {
    //bind init type list
    getCarrierVisitType()
      .then(res => {
        if (checkNested(res, "data", "content", "model")) {
          this.typeList = res.data.content.model;
          const { id } = this.typeList[0];
          this.typeId = -1;
          return getCarrierAreaList(id);
        }
      })
      .then(res => {
        // bind init area list
        if (checkNested(res, "data", "content", "model")) {
          this.areaList = res.data.content.model;
        }
      });

    // bind init bottlers list
    getVisitorBottlers()
    .then(res => {
      if (checkNested(res, "data", "content", "model")) {
        this.bottlers = res.data.content.model;
        console.log(res.data.content.model);
        if (this.bottlers.length == 1) {
          this.bottlerOption = this.bottlers;
          this.selectBottlerShow = true;
        } 
        this.isShowBottlersIcon = true;
      }
    });
    
    // bind init period time list
    getTimeSchedule()
    .then(res => {
      if (checkNested(res, "data", "content", "model")) {
        this.periodList = res.data.content.model
      }
    })
  },
  watch: {
    bottlerOption(value) {
      if(value) {
        this.errorMsgBottlerSelect = false;
      }
    }
  },
  methods: {
    selectTypeShowHide() {
      this.selectAreaShow = false;
      this.selectTypeShow = !this.selectTypeShow;
    },
    selectPeriodShowHide() {
      this.selectTypeShow = false;
      this.selectAreaShow = false;
      this.selectPeriodShow = !this.selectPeriodShow;
    },
    selectBottlerShowHide() {
      this.selectTypeShow = false;
      this.selectAreaShow = false;
      this.selectPeriodShow = false;
      this.selectBottlerShow = !this.selectBottlerShow;
    },
    checkTypeisNull() {
      if (this.isAreaDisabled == true) return;
      this.typeId == -1
        ? (this.isSelectTipsModalShown = true)
        : (this.selectAreaShow = !this.selectAreaShow);
    },
    // checkAreaisNull() {
    //   if (this.areaId == -1) {
    //     this.isSelectBottlerTipsModalShown = true;
    //   } else {
    //     this.selectTypeShow = false;
    //     this.selectAreaShow = false;
    //     this.selectBottlerShow = !this.selectBottlerShow;
    //   }
    // },
    handleTypeChange(id, name) {
      this.selectTypeShow = false;
      this.selectAreaShow = false;
      this.errorMsgTypeSelect = false;
      const typeId = id;
      if (this.typeList.findIndex(x => x.id === typeId) == -1) {
        this.areaList = [];
        this.typeId = -1;
      } else {
        this.selectTypeShowTxt = name;
        this.areaId = -1;
        this.selectAreaShowTxt = this.$t("SelectVisitArea");
        this.typeId = typeId;
        getCarrierAreaList(typeId).then(res => {
          if (checkNested(res, "data", "content", "model")) {
            this.areaList = res.data.content.model;
            if (this.areaList.length == 1) {
              this.areaId = this.areaList[0]["id"];
              this.selectAreaShowTxt = this.areaList[0]["name"];
              this.isAreaDisabled = true;
              this.isShowAreaIcon = false;
              this.errorMsgAreaSelect = false;
            } else {
              this.isAreaDisabled = false;
              this.isShowAreaIcon = true;
            }
          }
        });
      }
      
    },
    handleAreaChange(id, oneId, name) {
      this.selectAreaShowTxt = name;
      this.errorMsgAreaSelect = false;
      const areaId = id !== null ? id : oneId;
      if (this.areaList.findIndex(x => x.id === areaId) !== -1) {
        this.areaId = areaId;
      } else {
        this.areaId = -1;
      }
    },
    // handleBottlerChange(BottlerId, name) {
    //   if (this.isBottlersDisabled == true) return;
    //   this.selectBottlingShowTxt = name;
    //   this.errorMsgBottlerSelect = false;
    //   this.bottlerId = BottlerId;
    //   this.showOrder = true;
    // },
    handleDateChange() {
      const { startEndDate } = this;
      const date = new Date();
      let diff = 0;
      const isTrue = Moment(startEndDate).isBefore(date, 'day');

      if (startEndDate) {
        if (isTrue) {
          this.errorMsgDate = true;
          this.errorDate = this.$t("entered");
        } else {
          this.errorMsgDate = false;
          this.errorDate = "";
        }
      }
    },

    handlePeriodChange(id, name) {
      this.period_Id = id;
      this.selectPeriod = name;
      this.selectPeriodShow = false;
      this.errorPeriodDate = false;
    },
    isClearData() {
      this.isClear = true;
    },
    clearData() {
      this.isClear = false;
      this.typeId = -1;
      this.areaId = -1;
      this.startEndDate = "";
      this.period_Id = -1;

      if (this.bottlers.length != 1) {
        this.bottlerOption = [];
      } 
      this.bottlers.forEach(item => {
        item.orderNumber = ""
      });
      
      this.selectTypeShowTxt = this.$t("SelectType");
      this.selectAreaShowTxt = this.$t("SelectVisitArea");
      this.notSelectTips = this.$t("PleaseChooseVisitType");
      this.selectPeriod = this.$t("ExpectedTime"); 
    },
    checkData() {
      this.errorMsgDate = this.errorMsgDate || !this.startEndDate;
      this.errorDate = !this.startEndDate
        ? this.$t("pleaseSelectAccessTime")
        : this.errorDate;
      this.errorMsgTypeSelect = this.typeId === -1;
      this.errorMsgAreaSelect = this.areaId === -1;
      this.errorPeriodDate = this.period_Id === -1;
      this.errorMsgBottlerSelect = this.bottlerOption == '';

      if (
        !this.errorMsgDate &&
        !this.errorMsgTypeSelect &&
        !this.errorMsgAreaSelect &&
        !this.errorMsgAreaSelect &&
        !this.errorPeriodDate &&
        !this.errorMsgBottlerSelect
      ) {
        this.isCommit = true;
      }
    },
    commitData() {
      const bottlerData = [];
      this.bottlerOption.forEach(item => {
        let dataObj = {};
        if(item.orderNumber) {
          dataObj.orderNumber = item.orderNumber;
        } else {
          dataObj.orderNumber = ''
        }
        dataObj.bottlerId = item.id;
        bottlerData.push(dataObj);
      });
      
      const postData = {
        areaId: this.areaId,
        visitorTypeId: this.typeId,
        visitDay: this.startEndDate,
        timeScheduleId: this.period_Id,
        carrierBottlers: bottlerData
      };
      
      this.isLoading = true;
      this.isCommit = false;
      let _this = this;
      console.log('提交数据');
      console.log(postData);
      console.log(JSON.stringify(postData));
      
      applyInvitation(postData).then(res => {
        if (res.data.content.status === 1) {
          _this.DetailId = res.data.content.model.id;
          _this.addSucess = this.$t("SubmittedSuccessfully");
        } else {
          _this.addSucess = res.data.content.message;
        }
        _this.isConfirm = true;
        _this.isLoading = false;
      });
    },
    closeModal() {
      if (this.addSucess === this.$t("SubmittedSuccessfully")) {
        this.typeId = -1;
        this.areaId = -1;
        this.startEndDate = "";
        this.period_Id = -1;
        this.bottlerId = -1;
        this.orderNumber = "";
        const id = this.DetailId;
        this.$router.push({
          path: `/external/detailIndex/${id}/0`
        });
      } else {
        this.isCommit = false;
        this.isConfirm = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.order-input {
  text-align: right;
}
.btn-con {
  text-align: center;
  overflow: hidden;
  padding: 30px 0 60px;
}
.newInvisitContent .new-invisit-content .btn-con {
  .commit-btn {
    display: inline-block;
    width: 160px;
    margin: 0 20px;
    vertical-align: top;
    cursor: pointer;
    &.first {
      border: #ccc 1px solid;
      background-image: none;
      span {
        color: #4a4a4a;
      }
    }
  }
}
.new-invite-title {
  font-weight: bold;
  font-size: 14px;
  .icon-add {
    color: #e42029;
    font-size: 18px;
    margin-right: 10px;
    font-weight: normal;
    vertical-align: middle;
    position: relative;
    top: -1px;
  }
  .content-remarks {
    font-weight: normal;
    font-size: 12px;
    color: #929292;
  }
}
.invisitArea {
  select.un-selected {
    color: #929292 !important;
  }
}
</style>
<style scoped lang="scss">
@import "../scss/variables.scss";
html,
body,
#app {
  min-height: 100%;
  overflow: visible;
}
.bottler-check {
  font-size: 13px;
  color: #4a4a4a;
  .bottler-check-item {
    margin: 6px 4px;
  }
  .l {
    display: inline-block;
    float: left;
    margin-top: 2px;
  }
  .r {
    input {
      padding-right: 4px;
    }
  }
  label {
    margin-bottom: 0;
  }
  input[type='checkbox'] {
    width: 16px;
    height: 16px;
    appearance: none;
    background-color: #fff;
    outline: none;
    vertical-align: text-bottom;
    margin-bottom: -4px;
    margin-right: 4px;
    background: url(../assets/images/copy-21.png) no-repeat center;
    background-size: 100%;
    vertical-align: top;
    display:inline-block;
  }
  input[type='checkbox']:checked {
    background: url(../assets/images/11-copy.png) no-repeat center;
    background-size: 100%;
  }
}
.invisitBottling {
  .icon-right {
    display: inline-block;
    transition: all 300ms ease;
    vertical-align: middle;
  }
  span {
    color: #4a4a4a !important;
    margin-right: 5px;
    width: 70%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
  .active {
    .icon-right {
      transition: all 300ms ease;
      transform: rotate(90deg);
    }
  }
}

.newInvisitContent {
  & > div:first-child {
    padding: 50px 8% 5px;
    font-size: 18px;
    color: #4a4a4a;
    line-height: 1;
    font-weight: bold;
    i {
      float: right;
      font-size: 22px;
      font-weight: normal;
    }
  }
  .new-invisit-content {
    width: 100%;
    & > div:first-child {
      width: 84%;
      margin: auto;
    }
    .main-invisit {
      width: 100%;
      margin: 0 auto;
      padding: 0 12px;
      margin-bottom: 15px;
      background-color: #fff;
      border-radius: 4px;
      & > div:first-child {
        padding: 20px 0;
        font-size: 14px;
        color: #4a4a4a;
      }
      & > div:last-child {
        div.row {
          margin: 0;
          padding-top: 17px;
          &:first-child {
            padding-top: 0;
            border-bottom: 1px solid #f0f1f2;
          }
          & + .row {
            border-top: 1px solid #f0f1f2;
          }
          &.form-error {
            border-bottom: 1px solid #e42029;
          }
          div {
            padding: 0 0 16px;
            font-size: 13px;
            color: #4a4a4a;
            &:last-child {
              text-align: right;
            }
            input {
              color: #4a4a4a;
              text-align: right;
              border: none;
              outline: none;
              width: 100%;
            }
          }
        }
        .control-label {
          margin: 0;
          display: block;
          border-right: 1px solid #f0f1f2;
          i {
            font-size: 12px;
            padding-left: 2.5vw;
            display: inline-block;
            transform: scale(0.75, 0.75);
          }
        }
        .contact-select {
          position: fixed;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background: rgba(0, 0, 0, 0.4);
          z-index: 99;
          .inner {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            border-radius: 10px 10px 0 0;
            padding-bottom: 0;
            overflow: hidden;
            background: #f2f2f2;
          }
          .form-group {
            padding: 0;
            width: 90%;
            margin: 0 auto;
            & + .form-group {
              border-top: 1px solid #ddd;
            }
          }
          input {
            display: none;
            &:checked + label {
              color: #e42029;
            }
          }
          label {
            margin-bottom: 0;
            padding: 13px;
            font-size: 20px;
            text-align: center;
            display: block;
          }
        }
      }
    }
    .invisitMessage {
      width: 100%;
      margin: 0 auto;
      padding: 0 12px;
      background-color: #fff;
      border-radius: 4px;
      & > div:first-child {
        padding: 20px 0;
        font-size: 14px;
        color: #4a4a4a;
      }
      & > div:last-child {
        .typeList {
          position: relative;
          color: #4a4a4a;
          cursor: pointer;
          & > div {
            span {
              color: #4a4a4a !important;
              margin-right: 5px;
              width: 70%;
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              vertical-align: middle;
            }
            i {
              vertical-align: middle;
            }
          }
          div {
            input {
              cursor: pointer;
              text-align: right !important;
              margin-right: 5px;
              color: #4a4a4a;
              width: 70% !important;
              &:disabled {
                background: #fff;
              }
            }
          }
          ul {
            position: absolute;
            right: 10px;
            top: 25px;
            width: 60%;
            text-align: left;
            border: 1px solid #929292;
            background: #fff;
            z-index: 20;
            overflow: auto;
            max-height: 240px;
            @include respond-to("sm-max") {
              width: 70%;
            }
            li {
              list-style: none;
              cursor: pointer;
              padding: 5px 8px;
              &:hover {
                background: #0074e8;
                color: #fff;
              }
            }
          }
        }
        .areaList {
          input {
            cursor: pointer;
            &:disabled {
              background: #fff;
            }
            width: 70% !important;
          }
        }
        div.row {
          margin: 0;
          padding: 15px 0;
          border-bottom: 1px solid #f0f1f2;
          &:first-child {
            padding-top: 0;
            &.form-error {
              border-bottom: 1px solid red;
            }
          }
          &.form-error {
            border-bottom: 1px solid red;
          }
          div {
            &:last-child {
              text-align: right;
            }
            padding: 0;
            font-size: 13px;
            color: #4a4a4a;
            span {
              color: #e42029;
            }
          }
          .invisitTime {
            label {
              margin-bottom: 0;
              position: absolute;
              right: 20px;
              font-size: 13px;
            }
          }
          .invisitArea {
            select {
              -webkit-appearance: none;
              border: none;
              background: url("../assets/images/arrow-copy.png") no-repeat right;
              background-size: 8px;
              padding-right: 20px;
              color: #4a4a4a;
              text-align: right;
            }
          }
        }
        .add-more {
          border-top: 1px solid #f0f1f2;
          .add-more-btn {
            padding: 16px 0;
            font-size: 14px;
            color: #4a4a4a;
            img {
              width: 20px;
              height: 23px;
              margin-right: 10px;
            }
          }
        }
        .invisitPeriod {
          ul {
            width: 100px;
          }
        }
      }
    }
    .add-detail-info {
      padding: 0 12px;
      & > div:first-child {
        padding: 20px 0;
        .optional {
          color: #929292;
          font-weight: normal;
        }
      }
      .detail {
        & > div:first-child,
        & > div:nth-of-type(2) {
          width: 100%;
          padding-bottom: 15px;
          div:first-child {
            font-size: 13px;
            color: #4a4a4a;
            padding-bottom: 12px;
          }
          textarea {
            width: 100%;
            background-color: #f0f0f0;
            font-size: 13px;
            color: #4a4a4a;
            border: 0;
            padding: 5px 10px;
          }
        }
      }
    }
    .selectCourse-detail {
      margin-top: 16px;
    }
    .select-language {
      width: 100%;
      margin: 0 auto;
      padding: 12px;
      margin-bottom: 15px;
      background-color: #fff;
      border-radius: 4px;
      .down-language {
        position: relative;
        text-align: right;
        & > div {
          cursor: pointer;
          span {
            color: #4a4a4a;
            font-size: 13px;
            margin-right: 5px;
          }
        }
        input {
          width: 66px;
          margin-right: 10px;
          font-size: 13px;
          color: #4a4a4a;
          text-align: right;
          margin-right: 5px;
          cursor: pointer;
        }
        ul {
          position: absolute;
          top: 25px;
          right: 10px;
          background: #fff;
          border: 1px solid #929292;
          width: 110px;
          text-align: left;
          li {
            &:hover {
              background: #0074e8;
              color: #fff;
            }
            list-style: none;
            line-height: 24px;
            color: #4a4a4a;
            font-size: 14px;
            cursor: pointer;
          }
        }
      }
      & > div {
        select {
          width: 100%;
          -webkit-appearance: none;
          border: none;
          background: url("../assets/images/arrow-copy.png") no-repeat right;
          background-size: 8px;
          padding-right: 20px;
          font-size: 13px;
          color: #4a4a4a;
          text-align: right;
        }
      }
    }
    .commit-btn {
      width: 100%;
      height: 46px;
      line-height: 46px;
      text-align: center;
      border-radius: 5px;
      margin-top: 40px;
      margin-bottom: 40px;
      background-image: linear-gradient(81deg, #f36443, #e42029);
      span {
        font-size: 15px;
        font-weight: 600;
        color: #fff;
      }
    }
    .detail-list-show-up {
      padding: 12px;
      & > div.row {
        margin: auto;
        .title {
          color: #4a4a4a;
          font-size: 14px;
          padding-left: 20px;
          font-weight: bold;
          line-height: 24px;
          background: url("../assets/images/user-copy@3x.png") no-repeat center
            left;
          background-size: 17px auto;
        }
        .col-3 {
          padding: 0;
          text-align: right;
          cursor: pointer;
          i {
            font-size: 12px;
            padding-left: 2.5vw;
            display: inline-block;
            -webkit-transform: scale(0.75, 0.75);
            transform: scale(0.75, 0.75);
          }
        }
      }
    }
    .new-invite-row {
      margin-bottom: 15px;
      border-radius: 4px;
      background: #fff;
      //overflow: hidden;
      box-shadow: 0 0 25px rgba(100, 100, 100, 0.15);
      &.visitor-detail-list-row {
        margin-bottom: 15px;
      }
    }
    .add-more-btn {
      i {
        font-size: 18px;
        margin-right: 5px;
        color: #e42029;
      }
      span {
        font-weight: bold;
      }
    }
    .bottlingBox {
      .bottlingSelect {
        margin: 0;
        padding: 0;
        border-bottom: 1px solid #f0f1f2;
        padding-bottom: 15px;
        div {
          font-size: 13px;
          color: #4a4a4a;
          padding: 0;
          cursor: pointer;
        }
        div:last-child {
          text-align: right;
          div {
            span {
              color: #4a4a4a !important;
              margin-right: 5px;
              width: 85%;
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              vertical-align: middle;
            }
            i {
              vertical-align: middle;
            }
          }
        }
        .invisitBottling {
          ul {
            position: absolute;
            right: 10px;
            top: 25px;
            max-width: 80%;
            text-align: left;
            border: 1px solid #929292;
            background: #fff;
            z-index: 20;
            overflow: auto;
            max-height: 240px;
            li {
              list-style: none;
              cursor: pointer;
              padding: 5px 8px;
              &:hover {
                background: #0074e8;
                color: #fff;
              }
            }
          }
        }
      }
      .name-select {
        padding: 15px 0;
        margin: 0;
        &.form-error {
          border-bottom: 1px solid red;
        }
        div {
          font-size: 13px;
          color: #4a4a4a;
          padding: 0;
        }
        div:last-child {
          text-align: right;
          padding-right: 0;
          cursor: pointer;
          input {
            width: 90%;
            text-align: right;
            color: #4a4a4a;
            border: none;
            outline: none;
          }
          .select-ko {
            // background: url('../assets/images/arrow-copy.png') no-repeat right;
            // background-size: 8px;
            padding-right: 5px;
          }
        }
      }
    }
  }
  &.scrolled {
    border-radius: 0;
    //top: 0;
    & > div:first-child {
      padding-bottom: 20px;
      //box-shadow: 0 0 15px rgba(100, 100, 100, 0.2);
      // position: fixed;
      // width: 100%;
      //background: #fff;
      //z-index: 20;
    }
    // .new-invisit-content {
    //   height: 100vh;
    //   padding-top: 60px;
    // }
  }
  .error-msg {
    color: #e42029;
    font-size: 11px;
    text-align: right;
    width: 100%;
    &.right-padding {
      padding-right: 12px;
    }
  }
}
@media screen and (max-width: 767px) {
  .newInvisitContent {
    & > div[data-v-05b5e844]:first-child {
      padding: 20px 5% 20px;
    }
    .new-invisit-content {
      & > div:first-child {
        width: 90%;
      }
      .btn-con .commit-btn {
        width: 40%;
        margin: 0 4%;
      }
    }
  }
}
</style>
